import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Billbo.tv';
  PAGE_TITLE='HOLA';
  constructor(){
    
  }
}



// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/app.component.ts